(ns teamoesterreich.admin-mode.ui-helper.email-block-edit-card
  (:require
    [teamoesterreich.util.helper :as h]                     ;;(h/event-value e)
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.admin-mode.data.text-block :as d-text-block]
    [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
    [teamoesterreich.view-state :as v-state]


    [reagent-material-ui.icons.done :refer [done]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.send-two-tone :refer [send-two-tone]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))

(defn get-templates [template-group]
  (when (not (and (get-in @v-state/app-state [:text-blocks (keyword template-group)])
                  (coll? (get-in @v-state/app-state [:text-blocks (keyword template-group)]))))
    (d-text-block/get-group-text-blocks template-group
                                        (fn [res]
                                          (let [res (reduce (fn [c [r e]]
                                                              ;(log/debug "check template " (clj->js e))
                                                              (if (and
                                                                    (or (nil? (:toeTextBlock-key e)) (= "" (:toeTextBlock-key e)))
                                                                    (not (false? (:toeTextBlock-active e))))
                                                                (assoc c
                                                                  r e)
                                                                c))
                                                            {}
                                                            res)]

                                            (swap! v-state/app-state assoc-in [:text-blocks (keyword template-group)] res))))))


(defn get-it [subject content on-save-fn & [{:keys [title subText additional-button on-cancel-fn template-group disabled save-message]}]]
  (let [!st (r/atom {:subject subject :body content :template "" :template-set false :invalidate 0})
        !editor-mode (r/cursor !st [:edit-mode])
        !template (r/cursor !st [:template])
        !templates (r/cursor v-state/app-state [:text-blocks (keyword template-group)])
        !template-set (r/cursor !st [:template-set])
        !subject (r/cursor !st [:subject])
        !body (r/cursor !st [:body])
        !invalidate (r/cursor !st [:invalidate])
        _ (get-templates template-group)
        ]
    (fn []
      [mui/card
       (when title
         [mui/card-header {:title (str title)}]
         )

       (if @!editor-mode
         [mui/card-content
          {:style {:minHeight "400px" :width "100%" :textAlign "left"}}
          [mui/grid {:container  true
                     :direction  "row"
                     :error      (< (count (str (:userDocument-type @!st))) 1)
                     :justify    "space-between"
                     :spacing    2
                     :style      {:paddingRight "5px"}
                     :alignItems "flex-start"}

           (when (and template-group (coll? @!templates))
             [mui/grid {:container false :item true :xs 8}
              [mui/input-label {:style {:font-size "12px"}} "Vorlage "]
              [mui/select
               {:fullWidth true
                :value     (or @!template "")
                :onChange  (fn [e]
                             (let [v (h/event-value e)]
                               (swap! !st assoc
                                      :template v
                                      :template-set (if (= "" v) false true))))
                }
               (for [[k v] (filter (fn [[k v]] (= (:toeTextBlock-type v) "email")) @!templates)]
                 ^{:key (str "template-" k)}
                 [mui/menu-item {:style {} :value k} (str (:toeTextBlock-name v))])
               ]
              ])
           (when (and template-group (coll? @!templates))
             (when template-group
               [mui/grid {:container false :item true :xs 4}
                [mui/button
                 {:style     {:float "right"}
                  :color     "secondary"
                  :variant   "contained"
                  :title     "Vorlage verwenden"
                  :disabled  (not @!template-set)
                  :startIcon (r/as-element [done])
                  :onClick   (fn []
                               (let [tmpl (get @!templates @!template)]
                                 (swap! !st assoc
                                        :body (:toeTextBlock-content tmpl)
                                        :subject (:toeTextBlock-subject tmpl)
                                        :invalidate (rand-int 100)
                                        :template-set false)
                                 ))
                  }
                 "verwenden"]]))

           [mui/grid {:container false :item true :xs 12}

            [mui/text-field
             {:onChange        (fn [e] (reset! !subject (h/event-value e)))
              :value           @!subject
              :fullWidth       true
              :InputLabelProps {:disableAnimation true :shrink true}
              :label           "Betreff"
              :multiline       false
              }]]


           [mui/grid {:container false :item true :xs 12}
            [edit-md-card/get-it-small !body @!invalidate]
            ]




           [mui/grid {:container false :item true :xs 12}
            [:div subText]]
           ]]

         [mui/card-content
          {:style {:minHeight "400px" :width "100%" :textAlign "left"}}
          [mui/text-field
           {:value           subject
            :disabled       true
            :InputLabelProps {:disableAnimation true :shrink true}
            :label           "Betreff"
            :multiline       false
            :style {:marginBottom "5px" :marginLeft "120px" :minWidth "300px"}
            }]
          [:br]
          [edit-md-card/preview !body]
          [:div {:style {:textAlign "center" :marginTop "15px"}} subText]
          ]
         )
       [mui/card-actions
        {:style {:marginTop "15px"}}
        (if @!editor-mode
          [mui/button {:variant   "contained"
                       :startIcon (r/as-element [keyboard-arrow-left])
                       :onClick   (fn []
                                    (when on-cancel-fn (on-cancel-fn))
                                    (swap! !st assoc :editor-content content :edit-mode false))
                       }
           "Abbrechen"]
          (when-not disabled
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [edit])
                         :onClick   #(reset! !editor-mode true)
                         }
             "Bearbeiten"]))

        (when @!editor-mode
          [mui/button {:variant   "contained"
                       :startIcon (r/as-element [save])
                       :color     "primary"
                       :onClick   (fn []
                                    (on-save-fn @!subject @!body)
                                    (swap! !st assoc :editor-content content :edit-mode false))
                       }
           "Speichern"])



        (when (and (not @!editor-mode) additional-button)
          additional-button)

        ]

       ]
      )))


